/**
 * @file Entry point for the React application.
 * Mounts the root React component (`App`) inside a `<BrowserRouter>`,
 * using React 18's `createRoot` API.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css"; // Global styles

// Mount the React application into the DOM element with id "root".
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* 
      Wrap the app in BrowserRouter to enable routing.
      The `basename` is dynamically loaded from VITE env var.
      This allows the app to be deployed to a subdirectory, e.g., `/admin/`.
    */}
   <BrowserRouter basename="/">
  <App />
</BrowserRouter>

  </React.StrictMode>
);
